import React from "react";
import SVGIcon, { IconProps } from "ui/SVGIcon";

const path =
  "M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z";

export default function Close(props: IconProps) {
  // This viewBox centers the path while keeping the size consistent with the other icons.
  return <SVGIcon path={path} viewBox="-5 -5 24 24" {...props} />;
}
